import { useState } from "react";
import Overlay from "./Overlay";
import styles from "./UploadModal.module.css";
import {Close} from "@mui/icons-material"
import axios from "axios"
import { config } from "../App";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router";


const UploadModal = ({closeModal}) => {
  const { enqueueSnackbar } = useSnackbar();

  const[genreValue,setGenreValue]=useState("All");
  const[ratingValue,setRatingValue]=useState("All");
  const[videoLinkValue,setVideoLinkValue]=useState();
  const[imageLink,setImageLinkValue]=useState();
  const[title,setTitleValue]=useState();
  const[releaseDate,setReleaseDate]=useState();
  const[validVideoLink, setValidVideoLink]=useState(false);


  const month=["Jan", "Feb", "Mar", "Apr", "May", "June",
  "July", "Aug", "Sept", "Oct", "Nov", "Dec"
];


  const genreDropdown=(event)=>{
    console.log(event.target.value);
    setGenreValue(event.target.value)
  }

  const ratingDropdown=(event)=>{
    console.log(event.target.value)
    setRatingValue(event.target.value)
  }

  const getVideoLink=(event)=>{
    console.log(event.target.value);
    setVideoLinkValue(event.target.value)
    checkValidVideoLink(event.target.value)
  }

  const getImageLink=(event)=>{
    setImageLinkValue(event.target.value)
  }

  const getTitle=(event)=>{
    setTitleValue(event.target.value);
  }

  const checkValidVideoLink=(value)=>{
    if(value.includes("youtube.com/embed/")){
      setValidVideoLink(true);
    }
  }

  const getReleaseDate=(event)=>{
    setReleaseDate(event.target.value);
  }

  const performAPIPost=async(event)=>{
    event.preventDefault();
    const getMonth=new Date(releaseDate).getMonth();
    const getdate=new Date(releaseDate).getDate();
    const getYear=new Date(releaseDate).getFullYear();
    const updatedDate=`${getdate} ${month[getMonth]} ${getYear}`;

    if(!validVideoLink)
    {
      enqueueSnackbar("Enter a valid video link including youtube.com/embed/ ",{variant:"error"})
    }
    const formData={
      "videoLink":videoLinkValue,
      "title":title,
      "genre":genreValue,
      "contentRating":ratingValue,
      "releaseDate":updatedDate,
      "previewImage":imageLink
    }
    try{
      const response=await axios.post(`${config.endpoint}`,formData);
      if(response.status===201){
        enqueueSnackbar("Video Uploaded Successfully",{variant:"success"})
        closeModal(false);
      }

    }catch(err){
      enqueueSnackbar(err.message,{variant:"error"});
    }

  }


  return (
    <>
      <Overlay >
          <div className={styles.mainContainer}>

        <div className={styles.formContainer}>
          <form onSubmit={performAPIPost}>
            <br/>

            <div className={styles.buttonsDiv}>
            <h4 className={styles.formHeading} >Upload Video</h4>
           <button className={styles.closeButton} onClick={()=>{
             closeModal(false);
           }} >
             <Close ></Close>
             </button> 
            </div>
              
            <input id="vLink-input" placeholder=" Video Link" required className={styles.input} onChange={getVideoLink} />
            <br/>

            <input id="iLink-input" placeholder=" Thumbnail Image Link" required className={styles.input} onChange={getImageLink}   />

            <input id="title-input" placeholder=" Title" required className={styles.input} onChange={getTitle} />
            <br></br>

            <select required id="genreDropdown" onChange={genreDropdown} className={styles.input}>
              <option value=" All" >All Genre</option>
              <option value=" Education" >Education</option>
              <option value=" Sports">Sports</option>
              <option value=" Comedy">Comedy</option>
              <option value=" Lifestyle">Lifestyle</option>
            </select>
            <br></br>
            <select
              placeholder="Suitable age for the clip" required
              id="ratingDropdown"
              onChange={ratingDropdown}
              className={styles.input}
              >
              <option value="All">All Content Rating</option>
              <option value="7+">7+</option>
              <option value="12+">12+</option>
              <option value="16+">16+</option>
              <option value="18+">18+</option>
            </select>
            <br></br>
      
            <input type="date" id="uploadDate" name="uploadDate" placeholder="Date" className={styles.input} onChange={getReleaseDate}></input>
            <div className={styles.buttonsDiv}>
            <button type="submit" className={styles.uploadButtton}>UPLOAD VIDEO</button>
            <button className={styles.cancelButton} onClick={()=>{
              closeModal(false);
            }}>CANCEL</button>
            </div>
            <br/>

          </form>
        </div>
            </div>
      </Overlay>
    </>
  );
};

export default UploadModal;
